import React from 'react';
import { CheckCircleIcon, XCircleIcon } from 'lucide-react';
export function AudienceSection() {
  const forYou = ['Profesionales de 30+ años que viven solos y sienten que el sueldo se les va en comida.', 'Personas que teletrabajan y terminan pidiendo delivery por falta de una despensa inteligente.', 'Hombres y mujeres que quieren ganarle a la inflación en Chile con datos reales, no consejos genéricos.'];
  const notForYou = ['Familias de 4 o más personas (este sistema es específico para hogares unipersonales).', 'Personas que no están dispuestas a cambiar de marca o visitar un mayorista una vez al mes.', 'Gente que busca recetas de cocina (esto es un manual de optimización financiera).'];
  return <section className="w-full bg-[#f1f5f9] py-16 px-4" data-id="element-16" data-mp="e24neu33iy7t">
      <div className="max-w-6xl mx-auto" data-id="element-17" data-mp="3crlm3ogzyumf">
        <div className="grid md:grid-cols-2 gap-8" data-id="element-18" data-mp="3cqjzcmqmcjov">
          <div className="bg-white rounded-lg p-8 shadow-md border-l-4 border-[#22c55e]" data-id="element-19" data-mp="3hpdfyo17cqt9">
            <h3 className="text-2xl font-bold text-[#1a2332] mb-6" data-id="element-20" data-mp="14bc5les90a73">
              Esto ES para ti si...
            </h3>
            <ul className="space-y-4" data-id="element-21" data-mp="zcr3f9tfrgg0">
              {forYou.map((item, index) => <li key={index} className="flex items-start gap-3" data-id="element-22" data-mp="uk7r0g6hircs" data-mpi={index}>
                  <CheckCircleIcon className="w-6 h-6 text-[#22c55e] flex-shrink-0 mt-0.5" data-id="element-23" data-mp="qje33mt1lcjw" />
                  <span className="text-gray-700 leading-relaxed" data-id="element-24" data-mp="qhl5ex0eq2o1">{item}</span>
                </li>)}
            </ul>
          </div>

          <div className="bg-white rounded-lg p-8 shadow-md border-l-4 border-[#ef4444]" data-id="element-25" data-mp="gk6pqzmb5hws">
            <h3 className="text-2xl font-bold text-[#1a2332] mb-6" data-id="element-26" data-mp="bldd19euhuxo">
              Esto NO es para ti si...
            </h3>
            <ul className="space-y-4" data-id="element-27" data-mp="7luzwzt9mo5e">
              {notForYou.map((item, index) => <li key={index} className="flex items-start gap-3" data-id="element-28" data-mp="25yv2j1yt91vc" data-mpi={index}>
                  <XCircleIcon className="w-6 h-6 text-[#ef4444] flex-shrink-0 mt-0.5" data-id="element-29" data-mp="21y1em8ldbn2g" />
                  <span className="text-gray-700 leading-relaxed" data-id="element-30" data-mp="3vhjuwfxn87wn">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}